export const formLabel = {
    display: "flex",
    flexDirection: "row",
    flex: "1",
    alignItems: "center"
};
